<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-payment :show.sync="showFilterPop" :type="'payment'" @handlequery="handleFqueryFilter" />
    <add-btn v-hasPermi="['cont:newIncome:add']" @add="handleAddPayment" />
    <van-tabs v-model="active" @change="handleClick">
      <van-tab name="0" title="全部" :badge="countItem.allCount != 0?countItem.allCount:''"></van-tab>
      <van-tab name="1" title="公海" :badge="countItem.seaCount != 0?countItem.seaCount:''"></van-tab>
      <van-tab name="2" title="未认领" :badge="countItem.nogetCount != 0?countItem.nogetCount:''"></van-tab>
      <van-tab name="3" title="部分认领" :badge="countItem.noconfirmCount != 0?countItem.noconfirmCount:''"></van-tab>
      <van-tab name="4" title="已认领" :badge="countItem.getCount != 0?countItem.getCount:''"></van-tab>
      <van-tab name="5" title="异常" :badge="countItem.errorCount != 0?countItem.errorCount:''"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
        <div style="display: flex; align-items: center; height:100%; width:100%">
          <div style="flex: 1;">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.custName}}<van-tag color="#f7f8fa;" style="margin-left: 10px;">{{ item.contNewIncomeId }}</van-tag>
                <van-tag plain :type="typeArr[item.checkStatus]" style="margin-left: 10px;">{{statusArr[item.checkStatus]}}</van-tag>
              </div>
            </div>
            <div style="font-size: 12px">
              <span style="color: #ff976a;">收款:{{item.payMoney}}(元)</span>
              <span style="color: #07c160;margin-left: 5px">已认领:{{item.confirmMoney || '0'}}(元)</span>
            </div>
            <div style="font-size: 12px">
              <span style="color: #ee0a24;">可认领:{{item.noConfirmMoney || '0'}}(元)</span>
              <span style="color: #ee0a24;margin-left: 5px">待确认:{{item.totalMoney || '0'}}(元)</span>
            </div>
            <div style="color: #333; font-size: 12px">{{item.payBank}} 账号: {{item.payBankAccountNo}}</div>
            <div style="color: #999; font-size: 12px">对应业务员:{{item.userName}}</div>
            <div style="color: #999; font-size: 12px">收款日期:{{item.payDate}}</div>
            <div style="color: #999; font-size: 12px">{{item.createBy +'  ' + item.createTime}}</div>
          </div>
          <van-icon style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <van-dialog v-model="paymentVisible" class="cust" width="95%" style="height: 85%" title="添加收款信息" :showConfirmButton = 'false' :close-on-click-overlay="true">
      <van-form ref="paymentForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-tag type="warning">短信信息</van-tag>
        <van-cell title="短信内容" required :border="false"></van-cell>
        <van-field v-model="paymentForm.msgContent" rows="5" @input="smsTell" clearable autosize type="textarea" placeholder="请粘贴短信内容" style="border: 1px solid #d4d4d4; border-radius: 5px" />
        <van-tag type="success" style="margin-top: 12px;">识别信息</van-tag>
        <van-field v-model="paymentForm.custName" label="付款单位" placeholder="请输入付款单位" :rules="[{ required: true }]" required />
        <van-field v-model="paymentForm.companyName" readonly @click="showPicker('company')" label="收款主体" placeholder="请选择收款主体" :rules="[{ required: true }]" required />
        <van-field v-model="paymentForm.incomeBankName" readonly @click="paymentForm.companyId?showPicker('incomeBank'):''" label="收款银行账号" placeholder="请选择收款银行账号" :disabled="!paymentForm.companyId" :rules="[{ required: true }]" required />
        <van-field v-model="paymentForm.payMoney" label="收款金额(元)" placeholder="请输入金额" :rules="[{ required: true }]" type="number" maxlength="11" required />
        <van-field v-model="paymentForm.payDate" readonly clickable name="calendar" label="收款时间" placeholder="点击选择收款时间" @click="showDatePicker" :rules="[{ required: true }]" required />
        <div style="text-align: center;margin-top: 10px;">
          <van-button size="small" type="info" @click="savePayment" style="padding: 0 20px; border-radius: 5px;">保存</van-button>
          <van-button size="small" type="warning" native-type="button" @click="paymentForm = {}" style="padding: 0 20px; border-radius: 5px;margin-left: 10px">清空</van-button>
          <van-button size="small" type="default" @click="paymentVisible = false" style="padding: 0 20px; border-radius: 5px;margin-left: 10px">取消</van-button>
        </div>
      </van-form>
    </van-dialog>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-popup v-model="datePicker.visible" position="bottom">
      <van-datetime-picker v-model="datePicker.date" type="datetime" title="选择收款时间" :min-date="datePicker.minDate" @confirm="datePickerConfirm" @cancel="datePicker.visible = false" />
    </van-popup>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchPayment from './Search.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Toast, Tab, Tabs, DatetimePicker } from 'vant'
import AddBtn from '@/components/common/AddBtn'
import { companyList } from '@/api/admi/dept'

export default {
  name: 'approve',
  components: {
    AddBtn,
    SearchComponent,
    SearchPayment,
    EmptyComponent,
    TotalComponent,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast
  },
  data() {
    return {
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      countItem: {},
      showFilterPop: false,
      custList: [],
      paymentFormShow: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        checkStatus: null,
        companyId: null,
        bankType: 1,
        teamName: null,
        scrollTop: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      statusArr: ['', '未认领公海', '未认领', '部分认领', '已认领', '异常'],
      typeArr: ['', 'danger', 'danger', 'warning', 'success', 'primary'],
      paymentVisible: false,
      paymentForm: {},
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      deptList: [],
      payBankList: [],
      datePicker: {
        visible: false,
        date: new Date(),
        minDate: new Date(2020, 0, 1)
        // maxDate: new Date(2042, 11, 31)
      }
    }
  },
  created() {

  },
  async mounted() {
    // 存在 读缓存
    if (sessionStorage.getItem('paymentSearch')) {
      this.queryParams = JSON.parse(sessionStorage.getItem('paymentQuery'))
      this.queryParams.pageSize = this.queryParams.pageNum * 10
      this.queryParams.pageNum = 1
      document.documentElement.scrollTop = this.queryParams.scrollTop
      this.active = this.queryParams.checkStatus
    } else {
      sessionStorage.removeItem('paymentQuery')
    }
    if (this.$route.query.active) {
      this.active = this.$route.query.active
      this.queryParams.checkStatus = this.$route.query.active
    }
    await this.handleList()
    await this.getCountItem()
    await this.init()
    if (sessionStorage.getItem('paymentSearch')) {
      document.documentElement.scrollTop = this.queryParams.scrollTop
    }
  },
  destroyed() {
    // 销毁组件
    sessionStorage.removeItem('paymentSearch')
    // sessionStorage.removeItem('paymentQuery')
  },
  methods: {
    async init() {
      document.title = '收款列表'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.teamName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      sessionStorage.removeItem('paymentSearch')
      sessionStorage.removeItem('paymentQuery')
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
      this.getCountItem()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      this.queryParams.scrollTop = scrollTop
      sessionStorage.setItem('paymentQuery', JSON.stringify(this.queryParams))
      this.$router.push({
        path: '/cont/payment/paymentDetail',
        query: { id: item.contNewIncomeId, active: this.active, type: 'payment' }
      })
    },
    async handleList() {
      this.loading = true
      const res = await payment.listNewIncome(this.queryParams)
      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        if (this.queryParams.pageSize > 10 && this.queryParams.pageNum == 1) {
          this.queryParams.pageNum = this.queryParams.pageSize / 10
          this.queryParams.pageSize = 10
        }
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    // 查询打款记录数量
    getCountItem() {
      // this.queryParams.checkStatus = null
      payment.newIncomeCount({ ...this.queryParams, checkStatus: null }).then(res => {
        if (res.code === 200) {
          this.countItem = res.data
        }
      })
    },
    onLoad() {
      this.handleList()
      this.getCountItem()
    },
    handleClick(tab, event) {
      if (tab == '0') {
        this.queryParams.checkStatus = null
      } else {
        this.queryParams.checkStatus = tab
      }
      this.queryCustList()
    },
    handleAddPayment() {
      sessionStorage.removeItem('paymentSearch')
      // this.paymentVisible = true
      this.$router.push({
        path: '/cont/payment/addPayment'
      })
    },
    getPayBankList(id) {
      this.payBankList = []
      payment.listPayBank({ companyId: id }).then((response) => {
        if (response.code === 200) {
          response.rows.forEach(item => {
            const obj = {
              incomeBankId: item.bankAccountId,
              incomeBankName: `${item.bankName}(${item.accountNum})`,
              incomeBankNo: item.accountNum
            }
            this.payBankList.push(obj)
          })
        }
      })
    },
    smsTell(val) {
      payment.smsTell({ msgContent: val }).then(res => {
        if (res.code == 200) {
          this.getPayBankList(res.data.companyId)
          this.paymentForm = res.data
          this.paymentForm.incomeBankName = `${this.paymentForm.payBank}(${this.paymentForm.payBankAccountNo})`
          this.datePicker.date = new Date(this.paymentForm.payDate)
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type == 'company') {
        // 获取公司信息
        if (this.deptList.length == 0) {
          await companyList().then((response) => {
            this.deptList = response.rows
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.companyName)
        this.picker.loading = false
      } else if (type == 'incomeBank') {
        // await this.getPayBankList(this.paymentForm.companyId)
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey === 'company') {
        this.paymentForm.companyName = this.deptList[key].companyName
        this.paymentForm.companyId = this.deptList[key].companyId
        await this.getPayBankList(this.paymentForm.companyId)
        this.paymentForm.incomeBankId = ''
        this.paymentForm.incomeBankName = ''
      } else if (this.picker.formKey === 'incomeBank') {
        this.paymentForm.incomeBankId = this.payBankList[key].incomeBankId
        this.paymentForm.incomeBankName = this.payBankList[key].incomeBankName
      } else {
        this.paymentForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.paymentForm[name] = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    showDatePicker() {
      this.datePicker.visible = true
    },
    datePickerConfirm(val) {
      this.paymentForm.payDate = this.formatDateTime(val)
      this.datePicker.visible = false
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    async savePayment() {
      await this.$refs.paymentForm.validate
      payment.addNewIncome(this.paymentForm).then(res => {
        if (res.code == 200) {
          Toast.success('新增收款成功')
          this.paymentVisible = false
          this.paymentForm = {}
          this.queryCustList()
        } else {
          Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.cust /deep/.van-dialog__content {
  padding: 0 20px;
}
</style>
